import $ from 'jquery'
import AjaxRequest from "../modules/ajax-request";

class NewsletterSubscription {
    constructor(element) {
        this.div = element;
        this.form = $(this.div).find("form");
        this.format = $(this.form).data("format");
        this.url = $(this.form).data("action");
        this.loadingElement = $(this.div).find(".add-load-element");

        this.clearData();
        this.bindEvents(this);
    }
    clearData() {
        $(this.form).removeAttr("data-action");
        $(this.form).removeAttr("data-format");
    }
    bindEvents(selfInstance) {
        $(this.form).on("submit", function (event) {
            selfInstance.submitForm(event);
        });
    }
    submitForm(event) {
        event.preventDefault();
        var _form = this.form;
        var _loadingElement = this.loadingElement;
        var _format = this.format;

        var ajaxRequest = new AjaxRequest({
            successCallback: function (response) {
                _loadingElement.removeClass('loading');
                $('.message_' + _format, _form)
                    .removeClass("is-success is-failure")
                    .addClass("is-success")
                    .text(response.message);
            },
            errorCallback: function (response) {
                _loadingElement.removeClass('loading');
                $('.message_' + _format, _form)
                    .removeClass("is-success is-failure")
                    .addClass("is-failure")
                    .text(response.responseJSON.message);
            }
        });

        _loadingElement.addClass("loading");

        ajaxRequest.makeCall(this.url, $(_form).serialize());
    }
}

export default NewsletterSubscription;